import React from 'react';

import { IconInfoCircle } from '@tabler/icons-react';

export const AIInsights = () => {
  return (
    <div className="w-ful h-[400px]">
      <div className="flex h-[36px]  items-center justify-start gap-3 bg-blue-300 p-3 text-[14px] leading-none  !text-pink-950">
        <div className="flex cursor-pointer items-center justify-start gap-1">
          <IconInfoCircle size="24px" />
          <p>NOTE</p>
        </div>
        <p className="font-medium">
          Summarization uses our generative A.I. model. Please review the results as this will help
          fine-tune the language model.{' '}
        </p>
      </div>
    </div>
  );
};
